require('es6-promise').polyfill()
import Vue from 'vue'

import Vuex from 'vuex'
Vue.use(Vuex)

// load global methods from external files
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'

const localStorageValue = localStorage.getItem('user')
let userValue = {}
if(localStorageValue){
  userValue = JSON.parse(window.atob(localStorage.getItem('user')))
}

//console.log("userValue======>", userValue)
const user = userValue


const message = {
  info: '',
  msg: '',
  errors: []
}

let countriesJsonForIb = {}

let countriesJsonForIb1 = localStorage.getItem("countryJson")


if(countriesJsonForIb1){
    countriesJsonForIb = JSON.parse(countriesJsonForIb1)
}


const loaders = {
  a: false,
  b: false,
  c: false
}

const store =  new Vuex.Store({
  state: {
    user,
    message,
    loaders,
    "countriesJsonForIb": countriesJsonForIb,
  },
  actions,
  getters,
  mutations,
  modules: {
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/store.js